
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {dispatchGetFormsValuesByQuery} from '@/store/main/actions';
import {AxiosResponse} from 'axios';

@Component({})
export default class SearchEngineDialog extends Vue {
  @Prop() public searchEngine;

  private dialog: boolean = false;
  private resolve: any = null;
  private reject: any = null;
  private messageStatus: any = null;


  private options: any = {
    maxWidth: 800,
    zIndex: 200,
  };

  @Watch('dialog')
  public watchDialog(val) {
    if (this.searchEngine) {
      this.searchEngine.query_builder.children.forEach((e) => e.query.query_value ? e.query.query_value = null : null);
    }
  }

  public open(options) {
    this.dialog = true;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private async search() {
    this.messageStatus = null;
    this.searchEngine.name = '';
    this.searchEngine.description = '';
    const response = await dispatchGetFormsValuesByQuery(this.$store,
        {skip: 0, limit: 100, query_builder: this.searchEngine,
          formID: Number(this.searchEngine.form_id)}) as unknown as AxiosResponse;
    if (response?.data?.items?.length > 0) {
      this.resolve(response.data.items[0]);
      this.dialog = false;
      this.messageStatus = null;
    } else {
      this.messageStatus = 'Registro não encontrado';
    }
  }

  private cancel() {
    this.resolve(false);
    this.dialog = false;
  }

}
